export default __webpack_public_path__ + "static/media/MITSUBISHI.7d43ced0.png";